import React from 'react';
import ReactDOM from 'react-dom/client';
import '../app/globals.css';
import ARGameView from '../view/ARGameView/ARGameView';

export { ARGameView };

export const mountARGameView = (
  elementId: string,
  props: { gameId: string; customDomain?: string }
) => {
  const element = document.getElementById(elementId);
  if (element) {
    const root = ReactDOM.createRoot(element);
    root.render(<ARGameView {...props} />);
  } else {
    console.error(`Element with id ${elementId} not found`);
  }
};
